import React from 'react';
import { businessInfo } from '../data/mock';
import { Phone, MapPin, Clock } from 'lucide-react';

const ContactSection = () => {
  return (
    <section id="contact" className="py-24 md:py-32 bg-[#1a1c1b]">
      <div className="container mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Left Content */}
          <div>
            <span className="text-[#888680] text-sm font-medium uppercase tracking-wide mb-4 block">
              İletişim
            </span>
            <h2 className="text-[#f97316] font-black text-4xl md:text-6xl uppercase leading-[0.85] mb-6">
              Bize<br />Ulaşın
            </h2>
            <p className="text-[#888680] text-lg leading-relaxed mb-10">
              Arızalı cihazınızı getirin, hızlıca tamir edelim. 
              Önce arayın, randevu alın!
            </p>

            {/* Contact Info */}
            <div className="space-y-6">
              <a
                href={`tel:${businessInfo.phone.replace(/\s/g, '')}`}
                className="flex items-center gap-4 group"
              >
                <div className="w-14 h-14 bg-[#4a2a10] rounded-full flex items-center justify-center group-hover:bg-[#f97316] transition-colors duration-300">
                  <Phone size={22} className="text-[#f97316] group-hover:text-white transition-colors duration-300" />
                </div>
                <div>
                  <span className="text-[#888680] text-sm uppercase tracking-wide block mb-1">Telefon</span>
                  <span className="text-[#f97316] font-bold text-xl">{businessInfo.phone}</span>
                </div>
              </a>

              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-[#4a2a10] rounded-full flex items-center justify-center">
                  <MapPin size={22} className="text-[#f97316]" />
                </div>
                <div>
                  <span className="text-[#888680] text-sm uppercase tracking-wide block mb-1">Adres</span>
                  <span className="text-[#f97316] font-medium">{businessInfo.address}</span>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-[#4a2a10] rounded-full flex items-center justify-center">
                  <Clock size={22} className="text-[#f97316]" />
                </div>
                <div>
                  <span className="text-[#888680] text-sm uppercase tracking-wide block mb-1">Çalışma Saatleri</span>
                  <span className="text-[#f97316] font-medium">{businessInfo.workingHours}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right - CTA Card */}
          <div className="bg-[#4a2a10] p-8 md:p-12 flex flex-col justify-center">
            <h3 className="text-[#f97316] font-black text-3xl md:text-4xl uppercase leading-tight mb-4">
              Hemen Arayın,<br />Randevu Alın!
            </h3>
            <p className="text-[#888680] text-lg leading-relaxed mb-8">
              Cihazınızın arızasını telefonda anlatın, size en uygun randevuyu belirleyelim.
            </p>
            <a
              href={`tel:${businessInfo.phone.replace(/\s/g, '')}`}
              className="inline-flex items-center justify-center gap-3 bg-[#f97316] text-white px-8 py-5 rounded-full font-bold text-xl uppercase tracking-wide hover:scale-[1.02] active:scale-[0.98] transition-transform duration-300"
            >
              <Phone size={24} />
              <span>{businessInfo.phone}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
